document.addEventListener("DOMContentLoaded", function() {
  const configElement = document.getElementById('juego-ofertas-data');
  if (!configElement) return; 
  
  const configData = configElement.dataset;
  const expiracionMinutos = parseInt(configData.expiracionMinutos) || 10;

  let estado = localStorage.getItem('habiram_estado_juego');
  let tiempoExpiracion = localStorage.getItem('habiram_tiempo_expiracion');
  const modal = document.getElementById('modal-overlay-caja');
  const fueCerrado = sessionStorage.getItem('habiram_modal_cerrado');

  // INTERACCIÓN VISUAL DEL CHECKBOX
  const checkboxTerminos = document.getElementById('acepto-terminos');
  const btnRevelar = document.getElementById('btn-revelar');
  const errorMsgTerminos = document.getElementById('error-terminos');
  const errorMsgCorreo = document.getElementById('error-correo');

  if (checkboxTerminos && btnRevelar) {
    checkboxTerminos.addEventListener('change', function() {
      if (this.checked) {
        btnRevelar.classList.remove('btn-desactivado');
        if(errorMsgTerminos) errorMsgTerminos.style.display = 'none';
      } else {
        btnRevelar.classList.add('btn-desactivado');
      }
    });
  }

  // VALIDADOR DE TIEMPO
  if (tiempoExpiracion) {
    const ahora = new Date().getTime();
    if (ahora > parseInt(tiempoExpiracion)) {
      limpiarMemoriaLocal();
      estado = null;
      tiempoExpiracion = null;
    }
  }

  // --- MOTOR DE ESTADOS POST-RECARGA ---
  if (estado === 'esperando_recarga') {
    // Si entró aquí, significa que acaba de regresar de validar el Captcha nativo de Shopify o de la recarga del formulario
    localStorage.setItem('habiram_estado_juego', 'ganador');
    modal.classList.add('activo');
    
    detonarPremioInicial();
    inyeccionDeDescuentoSilenciosa();

    if (typeof mostrarBarraUrgencia === 'function') {
      mostrarBarraUrgencia();
      if (typeof iniciarRelojGlobal === 'function') iniciarRelojGlobal();
    }
  } else if (estado === 'ganador' && tiempoExpiracion) {
    // Silencio absoluto. El snippet global se encarga.
  } else {
    // Es un usuario nuevo
    if (!fueCerrado) {
      setTimeout(() => { modal.classList.add('activo'); }, 1500);
    }
  }

  window.cerrarModalMisteriosa = function() {
    modal.classList.remove('activo');
    sessionStorage.setItem('habiram_modal_cerrado', 'true');
  };

  window.iniciarCaptura = function(elemento) {
    elemento.classList.add('seleccionada');
    
    const premios = [
      { msj: configData.p1Msj, codigo: configData.p1Cod, tag: 'gano_nivel_1' }, 
      { msj: configData.p2Msj, codigo: configData.p2Cod, tag: 'gano_nivel_2' }, 
      { msj: configData.p3Msj, codigo: configData.p3Cod, tag: 'gano_nivel_3' }  
    ];

    let probabilidad = Math.random() * 100;
    let premioSeleccionado = (probabilidad <= 60) ? premios[0] : (probabilidad <= 90) ? premios[1] : premios[2];

    localStorage.setItem('habiram_codigo_descuento', premioSeleccionado.codigo);
    localStorage.setItem('habiram_mensaje_descuento', premioSeleccionado.msj);
    localStorage.setItem('habiram_tag_ganado', premioSeleccionado.tag);

    setTimeout(() => {
      document.getElementById('zona-cajas').style.display = 'none';
      document.getElementById('zona-captura').style.display = 'block';
    }, 450);
  };

  // --- FLUJO MAESTRO DE VALIDACIÓN NATIVA ---
  window.procesarValidacionNativa = function() {
    const emailInput = document.getElementById('correo-reclamar').value;
    let hasError = false;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput)) {
      errorMsgCorreo.style.display = 'block';
      hasError = true;
    } else {
      errorMsgCorreo.style.display = 'none';
    }

    if (!checkboxTerminos.checked) {
      errorMsgTerminos.style.display = 'block';
      checkboxTerminos.parentElement.style.transform = 'translateX(5px)';
      setTimeout(() => checkboxTerminos.parentElement.style.transform = 'translateX(-5px)', 100);
      setTimeout(() => checkboxTerminos.parentElement.style.transform = 'translateX(0)', 200);
      hasError = true;
    } else {
      errorMsgTerminos.style.display = 'none';
    }

    if (hasError) return;

    btnRevelar.innerText = "PROCESANDO...";
    btnRevelar.classList.add('btn-desactivado');

    // 1. Inyectamos la etiqueta correcta en el formulario oculto
    const tagGanado = localStorage.getItem('habiram_tag_ganado') || '';
    document.getElementById('input-tags-oculto').value = `${tagGanado}, suscrito_caja_misteriosa`;

    // 2. Marcamos el estado en la memoria ANTES de que la página recargue
    localStorage.setItem('habiram_estado_juego', 'esperando_recarga');

    // 3. Disparamos el formulario oficial ubicándolo por su contenedor (A prueba de errores de VFS)
    document.querySelector('#contenedor-formulario-oficial form').submit();
  };

  window.irACatalogo = function() {
    const urlDestino = '/collections/all'; 
    const codigoReal = localStorage.getItem('habiram_codigo_descuento');
    window.cerrarModalMisteriosa();
    
    if(codigoReal) {
      window.location.href = `/discount/${codigoReal}?redirect=${urlDestino}`;
    } else {
      window.location.href = urlDestino;
    }
  };

  function inyeccionDeDescuentoSilenciosa() {
    const codigoReal = localStorage.getItem('habiram_codigo_descuento');
    if (codigoReal) {
      fetch(`/discount/${codigoReal}`).catch(e => console.log('Cupón inyectado'));
    }
  }

  function detonarPremioInicial() {
    if(!localStorage.getItem('habiram_tiempo_expiracion')) {
       localStorage.setItem('habiram_tiempo_expiracion', new Date().getTime() + (expiracionMinutos * 60000));
    }
    
    document.getElementById('zona-cajas').style.display = 'none';
    document.getElementById('zona-captura').style.display = 'none';
    document.getElementById('zona-premio').style.display = 'block';
    
    document.getElementById('premio-mensaje-display').innerText = localStorage.getItem('habiram_mensaje_descuento');
    document.getElementById('premio-codigo-display').innerText = localStorage.getItem('habiram_codigo_descuento');

    var duration = 3000; 
    var end = Date.now() + duration;
    (function frame() {
      if(typeof confetti === 'function') {
        confetti({ particleCount: 7, angle: 60, spread: 60, origin: { x: 0 }, zIndex: 9999999, colors: ['#ff6600', '#000000', '#ffffff', '#ffcc00'] });
        confetti({ particleCount: 7, angle: 120, spread: 60, origin: { x: 1 }, zIndex: 9999999, colors: ['#ff6600', '#000000', '#ffffff', '#ffcc00'] });
      }
      if (Date.now() < end) requestAnimationFrame(frame);
    }());
    
    iniciarRelojModal();
  }

  function iniciarRelojModal() {
    const expiracion = parseInt(localStorage.getItem('habiram_tiempo_expiracion'));
    const displayModal = document.getElementById('temporizador-local-modal');

    const intervalo = setInterval(() => {
      const ahora = new Date().getTime();
      const distancia = expiracion - ahora;
      
      if (distancia <= 0) {
        clearInterval(intervalo);
        if(displayModal) displayModal.innerText = "EXPIRADO";
        limpiarMemoriaLocal();
      } else {
        let minutos = Math.floor((distancia % (1000 * 60 * 60)) / (1000 * 60));
        let segundos = Math.floor((distancia % (1000 * 60)) / 1000);
        if(displayModal) displayModal.innerText = `${minutos}:${segundos < 10 ? '0' : ''}${segundos}`;
      }
    }, 1000);
  }

  function limpiarMemoriaLocal() {
    localStorage.removeItem('habiram_estado_juego');
    localStorage.removeItem('habiram_tiempo_expiracion');
    localStorage.removeItem('habiram_codigo_descuento');
    localStorage.removeItem('habiram_mensaje_descuento');
    localStorage.removeItem('habiram_tag_ganado');
  }
});